import { Checkbox, Form, CheckboxOptionType, FormInstance } from "antd";
import { CheckboxValueType } from "antd/es/checkbox/Group";
import { useEffect, useMemo } from "react";
import DOCUMENT_VISIBILITY from "../../../../../../../types/enums/DocumentVisibility";

type VisibilityFormItemProps = {
  form: FormInstance;
  name?: string[];
};

export const VisibilityFormItem = ({ form, name }: VisibilityFormItemProps) => {
  const fieldName = name || "visibility";

  const visibilityOptions: CheckboxOptionType[] = useMemo(
    () => [
      {
        label: "Primary Seller",
        value: DOCUMENT_VISIBILITY.PrimarySeller
      },
      {
        label: "Primary Buyer",
        value: DOCUMENT_VISIBILITY.PrimaryBuyer
      },
      {
        label: "Secondary Seller",
        value: DOCUMENT_VISIBILITY.SecondarySeller
      },
      {
        label: "Secondary Buyer",
        value: DOCUMENT_VISIBILITY.SecondaryBuyer
      }
    ],
    []
  );

  const handleChange = (checkedValues: CheckboxValueType[]) => {
    if (checkedValues.length === 0) {
      checkedValues = [DOCUMENT_VISIBILITY.None];
    }
    form.setFieldValue(fieldName, checkedValues);
  };

  useEffect(() => {
    const currentValue = form.getFieldValue(fieldName);
    if (!currentValue || currentValue.length === 0) {
      form.setFieldValue(fieldName, [DOCUMENT_VISIBILITY.None]);
    }
  }, [form, fieldName]);

  return (
    <Form.Item label="Portal Visibility" name={fieldName} className="mb-6 w-100">
      <Checkbox.Group
        options={visibilityOptions}
        onChange={handleChange}
        className="d-flex flex-column visibility-options mt-1"
      />
    </Form.Item>
  );
};
